import * as Ariakit from '@ariakit/react';
import styled, { css } from 'styled-components';
import { easeInOutCubic, fromMd, timingSlower, zIndexModal } from '../../../constants';
const drawerPositionCss = css(o => {
    const shared = {
        'top': 0,
        'transition': `${timingSlower} ${easeInOutCubic} all`,
        '&[data-enter]': {
            transform: 'translateX(0)',
        },
    };
    if (o.$dir === 'ltr') {
        return {
            left: 0,
            transform: 'translateX(-100%)',
            ...shared,
        };
    }
    return {
        right: 0,
        transform: 'translateX(100%)',
        ...shared,
    };
});
export const Drawer = styled(Ariakit.Dialog) `
  ${drawerPositionCss};
  background-color: ${o => o.theme.color.fill.background};
  position: fixed;
  height: 100svh;
  z-index: ${zIndexModal};
  width: 100svw;
  ${fromMd} {
    max-width: 50svw;
    width: auto;
  }
  overflow-y: auto;
`;
//# sourceMappingURL=styles.js.map